"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStripeCheckoutUrl = void 0;
const getStripeCheckoutUrl = (application, trackingSource, isTrial, referrer, promoCode) => {
    const url = `/${application}/content/stripe/checkout`;
    const params = new URLSearchParams();
    params.set("track", trackingSource);
    if (isTrial) {
        params.set("trial", "true");
    }
    if (referrer) {
        params.set("referrer", referrer);
    }
    if (promoCode) {
        params.set("promoCode", promoCode);
    }
    return `${url}?${params.toString()}`;
};
exports.getStripeCheckoutUrl = getStripeCheckoutUrl;
//# sourceMappingURL=checkoutPaths.js.map